import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection, RealProblemSection, SolutionSection, ModulesSection, ComparisonSection } from './components/ContentSections';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQAccordion } from './components/FAQAccordion';
import { SocialProofPopup } from './components/SocialProofPopup';
// Meta Pixel Type Definition
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45680841261217:1';
  // Initialize Meta Pixel - Full implementation matching Facebook's official code
  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;
    // Initialize fbq function if not exists
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    }
    // Load the Facebook Pixel script
    const scriptId = 'facebook-pixel-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
    // Initialize and track PageView
    window.fbq('init', '26355704687375920');
    window.fbq('track', 'PageView');
    // Add noscript fallback image
    const noscriptId = 'facebook-pixel-noscript';
    if (!document.getElementById(noscriptId)) {
      const noscript = document.createElement('noscript');
      noscript.id = noscriptId;
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=26355704687375920&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  const scrollToPrice = () => {
    const element = document.getElementById('pricing-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-yellow-200" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      {/* Hero Section */}
      <Hero onScrollToPrice={scrollToPrice} data-id="element-2" />

      {/* Problem Sections */}
      <ProblemSection onScrollToPrice={scrollToPrice} data-id="element-3" />
      <RealProblemSection data-id="element-4" />

      {/* Solution Section */}
      <SolutionSection onScrollToPrice={scrollToPrice} data-id="element-5" />

      {/* Modules Breakdown */}
      <ModulesSection data-id="element-6" />

      {/* Comparison */}
      <ComparisonSection data-id="element-7" />

      {/* Bonuses Section */}
      <section className="py-16 bg-white px-4" data-id="element-8">
        <div className="max-w-5xl mx-auto" data-id="element-9">
          <div className="text-center mb-12" data-id="element-10">
            <h2 className="text-3xl md:text-4xl font-black text-red-600 mb-4 uppercase" data-id="element-11">
              🎁 Regalos Especiales
            </h2>
            <p className="text-xl font-bold text-gray-800" data-id="element-12">
              BONOS INCLUIDOS HOY (sin costo adicional)
            </p>
          </div>

          <Bonuses onScrollToPrice={scrollToPrice} data-id="element-13" />
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16 bg-slate-900 px-4 relative" data-id="element-14">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-15"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-16">
          <div className="text-center text-white mb-12" data-id="element-17">
            <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-18">
              ⏰ OFERTA POR TIEMPO LIMITADO
            </h2>
            <p className="text-xl text-gray-300" data-id="element-19">
              Accedé hoy a CRIANZA SIN CELULAR + los 3 BONOS DE REGALO
            </p>
          </div>

          <Pricing checkoutUrl={CHECKOUT_URL} data-id="element-20" />
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50 px-4" data-id="element-21">
        <div className="max-w-6xl mx-auto" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-23">
            💬 LO QUE DICEN OTROS PADRES
          </h2>
          <Testimonials data-id="element-24" />
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 bg-white px-4" data-id="element-25">
        <div className="max-w-3xl mx-auto" data-id="element-26">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-27">
            ❓ PREGUNTAS FRECUENTES
          </h2>
          <FAQAccordion data-id="element-28" />
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-red-600 text-white px-4 text-center" data-id="element-29">
        <div className="max-w-3xl mx-auto" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-31">
            🌱 CRIAR PUEDE SER DIFERENTE
          </h2>
          <p className="text-xl md:text-2xl mb-4 opacity-90" data-id="element-32">
            No necesitás ser perfecto/a. Necesitás herramientas claras y un
            camino posible.
          </p>
          <p className="text-lg mb-10 opacity-80" data-id="element-33">
            Volvé a ser la presencia más importante en la vida de tus hijos...
          </p>

          <a href={CHECKOUT_URL} className="inline-flex items-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-red-900 text-2xl font-black py-5 px-10 rounded-full shadow-xl hover:scale-105 transition-transform" data-id="element-34">
            👉 OBTENER CRIANZA SIN CELULAR AHORA
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-gray-500 py-8 text-center text-sm" data-id="element-35">
        <div className="max-w-4xl mx-auto px-4" data-id="element-36">
          <p data-id="element-37">© 2024 Crianza Sin Celular. Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-38">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>
    </div>;
}